import React from "react";
import { FormattedMessage } from "react-intl";
import { ReactComponent as PaymentPendingImage } from "../../assets/images/Payment pending.svg";
import { ReactComponent as QParkLogo } from "../../assets/images/Q-Park - Quality in parking.svg";

const PaymentPending: React.FC = () => {
  return (
    <React.Fragment>
      <div className="main">
        <div className="content">
          <PaymentPendingImage className="status-pending" />
          <p className="App-status">
            <FormattedMessage id="pendingStatus" />
          </p>
          <p className="App-status-info">
            <FormattedMessage id="pendingStatusInfo" />
          </p>
        </div>
      </div>
      <div className="footer">
        <QParkLogo />
      </div>
    </React.Fragment>
  );
};

export default PaymentPending;
